export default {"src":"/_next/static/media/edit.6838062d.svg","height":374,"width":374,"blurWidth":0,"blurHeight":0};